const Loading = () => {
    let circleCommonClasses = 'h-12 w-12 bg-current   rounded-full mx-4 mt-6';

    return (
                <div className="flex flex-row justify-center">
                    <div className={`${circleCommonClasses} mr-1 animate-pulse`}></div>
                    <div
                        className={`${circleCommonClasses} mr-1 animate-pulse delay-400`}
                    ></div>
                    <div className={`${circleCommonClasses} animate-pulse delay-700`}></div>
                </div>
    )
}

export default Loading